import { render } from "./PersonThFirst.pug?vue&type=template&id=896a8fde&lang=pug"
import script from "./PersonThFirst.js?vue&type=script&lang=js"
export * from "./PersonThFirst.js?vue&type=script&lang=js"

import exportComponent from "/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__